import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Configurações',
    path: '/ferramentas/saeweb/configuracoes',
    name: 'saeweb_config',
    component: () => import('@/views/ferramentas/saeweb/configuracoes.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_CONFIGURACOES_MENU_2500200010
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'LOG de Auditoria',
    path: '/ferramentas/saeweb/log',
    name: 'log',
    component: () => import('@/views/ferramentas/saeweb/log.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_LOG_MENU_2500200100
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Monitoramento',
    path: '/ferramentas/saeweb/monitoramento',
    name: 'monitoramento',
    component: () => import('@/views/ferramentas/saeweb/monitoramento.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_MONITORAMENTO_MENU_2500200200
      ],
    },
    goesToMenu: true,
  },
]

